/*
 * For ES6+ features:
 * Either import '@babel/polyfill' here, or
 * use https://cdn.polyfill.io/v2/polyfill.min.js (default for this project)
 */

import "./index.css";
import { EventBus, EventTypes } from "./consts/const-event-types";

/*
To add new components, import them here and add them to the 'components'-array below.
Add an appropriate selectorName for use in DOM (fx: <div data-component="header"></div>):
*/
import App from "./components/app/app";
import Header from "./components/header/header";
import ExampleComponent from "./components/example-component/example-component";
import UserItem from "./components/user-item/user-item";
import Magic from "./components/magic/magic";
import ToggleModule from "./components/toggle-module/togglemodule";
import TestModule from "./components/test-module/test-module";
import LazyLoad from "./components/lazyload/lazyload";
import VimeoComponent from "./components/vimeo/vimeocomponent";
import Bestilling from "./components/bestilling/bestilling";
import Fixedcontact from "./components/contact/fixedcontact";
import CookiedisclaimerComponent from "./components/cookie/cookiedisclaimer";
import GlobalSearchComponent from "./components/search-component/search-component";
import Accordion from "./components/accordion/accordion";
import Basket from "./components/bestilling/basket";

const components = [
  { Class: App, selectorName: "app" },
  { Class: Header, selectorName: "header" },
  { Class: ExampleComponent, selectorName: "example-component" },
  { Class: UserItem, selectorName: "user-item" },
  { Class: Magic, selectorName: "magic" },
  { Class: ToggleModule, selectorName: "togglemodule" },
  { Class: TestModule, selectorName: "test-module" },
  { Class: LazyLoad, selectorName: "lazyload" },
  { Class: VimeoComponent, selectorName: "vimeocomponent" },
  { Class: Bestilling, selectorName: "bestilling" },
  { Class: Fixedcontact, selectorName: "fixedcontact" },
  { Class: CookiedisclaimerComponent, selectorName: "cookie-disclaimer" },
  { Class: GlobalSearchComponent, selectorName: "global-search" },
  { Class: Accordion, selectorName: "accordion"},
  { Class: Basket, selectorName: "basket"}
  
  
];

/*
 * ComponentInstantiator traverses the DOM-tree and looks for [data-component='] attributes.
 */
class ComponentInstantiator {
  constructor() {
    this.createComponents();
    this.dispatchReady();
    return this;
  }

  createComponents() {
    this.componentsInstantiated = {};

    components.map(component => {
      const nodes = [];
      // select all DOM-nodes with the data-component attribute:
      const nodeItems = [
        ...document.querySelectorAll(
          "[data-component='" + component.selectorName + "']"
        )
      ];

      nodeItems.map(nodeItem => {
        // instantiate component with nodeItem as param:
        nodes.push(new component.Class(nodeItem));
      });

      // add to componentsList object:
      if (nodes.length)
        this.componentsInstantiated[component.selectorName] = nodes;
    });
  }

  dispatchReady() {
    const event = new CustomEvent(EventTypes.ALL_COMPONENTS_READY);
    EventBus.dispatchEvent(event);
  }

  getComponents(selectorName) {
    return selectorName
      ? this.componentsInstantiated[selectorName]
      : this.componentsInstantiated;
  }
}

/* Make your App accessible via window.App */
window.App = new ComponentInstantiator();

/* Access components list */
//console.log("components on this page", window.App.getComponents());
